<template>
  <div
    :class="[
      'credit-card',
      `is-${validatedBrand || 'unknown'}`,
      {
        'has-image': brandImage,
        'has-number': numberText,
      },
    ]"
  >
    <component :is="brandImage || 'div'" class="credit-card-brand" role="image" />
    <div class="credit-card-number">{{ numberText }}</div>
  </div>
</template>

<script>
import { toString } from '@/helpers/convert';
import { hasOwnProperty } from '@/helpers/reflect';

const brands = {
  ...brandComponent('amex'),
  ...brandComponent('diners'),
  ...brandComponent('discover'),
  ...brandComponent('jcb'),
  ...brandComponent('mastercard'),
  ...brandComponent('unionpay'),
  ...brandComponent('visa'),
};

const dot = '\u2022';
const numberPrefix = `${dot.repeat(4)}\u00a0`.repeat(3);

export default {
  name: 'CreditCard',
  components: brands,
  props: {
    brand: {
      type: String,
      default: null,
    },
    number: {
      type: String,
      default: null,
    },
  },
  computed: {
    /**
     * @returns {string | null}
     */
    brandImage() {
      const brand = this.validatedBrand;
      return brand && brandComponentName(brand);
    },
    /**
     * @returns {string | null}
     */
    numberText() {
      const number = toString(this.number).replace(/\D/g, '').trim();
      if (!number) {
        return null;
      }
      return `${numberPrefix}${number.slice(-4).padStart(4, dot)}`;
    },
    /**
     * @returns {string | null}
     */
    validatedBrand() {
      let brand = toString(this.brand).trim();
      if (!brand) {
        return null;
      }
      brand = brand.toLowerCase();
      return hasOwnProperty(brands, brandComponentName(brand)) ? brand : null;
    },
  },
};

/**
 * @param {CreditCardBrand} brand
 * @returns {Record<string, import('vue/types').Component<any, any, any, any> | import('vue/types').AsyncComponent<any, any, any, any>>}
 */
function brandComponent(brand) {
  return {
    [brandComponentName(brand)]: () => import(`@/assets/credit-cards/${brand}.svg?inline`),
  };
}

/**
 * @param {string} brand
 * @returns {string}
 */
function brandComponentName(brand) {
  return `${brand}-card`;
}
</script>
